import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  EnvironmentProviders,
  provideBrowserGlobalErrorListeners,
  Provider,
  provideZonelessChangeDetection,
} from '@angular/core';
import { LuxonDateAdapter, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import {
  ApiErrorInterceptor,
  ApplicationHeaderInterceptor,
  AuthInterceptor,
  ClientMetadataInterceptor,
  ImpersonationInterceptor,
  provideOpenId,
} from '@workspace/ng-data-access';
import { provideBreadcrumb } from './breadcrumb';
import { provideErrorHandler } from './error-handler';
import { provideIcons } from './icons/provider';
import { provideLocalStorage } from './local-storage';
import { provideMedia } from './media';
import { provideNavigationTracker } from './navigation';
import { provideMatPaginatorIntl } from './paginator';
import { provideScrollMargin } from './scroll-margin';
import { provideTheming } from './theming';
import { provideWindow } from './window/provider';

export const commonProviders: (Provider | EnvironmentProviders)[] = [
  // Initiatilzation
  provideNavigationTracker(),
  provideOpenId,

  // Angular
  ...(typeof window !== 'undefined' ? [provideBrowserGlobalErrorListeners()] : []),
  provideZonelessChangeDetection(),
  provideHttpClient(
    withFetch(),
    withInterceptors([
      ApplicationHeaderInterceptor,
      ClientMetadataInterceptor,
      ApiErrorInterceptor,
      AuthInterceptor,
      ImpersonationInterceptor,
    ]),
  ),
  provideClientHydration(withIncrementalHydration()),

  // Aura
  provideWindow(),
  provideLocalStorage(),
  provideScrollMargin(),
  provideErrorHandler(),
  provideMatPaginatorIntl(),
  provideIcons(),
  provideMedia(),
  provideTheming({
    scheme: 'light',
    primary: '#3E63DD',
    error: '#E5484D',
    neutral: '#8B8D98',
  }),
  provideBreadcrumb(),

  // Material Date Adapter
  provideLuxonDateAdapter(),
  {
    provide: DateAdapter,
    useClass: LuxonDateAdapter,
  },
  {
    provide: MAT_DATE_FORMATS,
    useValue: {
      parse: {
        dateInput: 'D',
      },
      display: {
        dateInput: 'DDD',
        monthYearLabel: 'LLL yyyy',
        dateA11yLabel: 'DD',
        monthYearA11yLabel: 'LLLL yyyy',
      },
    },
  },
  { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
];
